import { c as _c } from "react/compiler-runtime";
import { Checkbox } from 'react-aria-components';
import styles from './AriaCheckbox.module.css';
import type { AriaCheckboxProps } from './AriaCheckbox.types';
function AriaCheckbox(t0) {
  const $ = _c(8);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children) {
    t1 = t2 => {
      const {
        isIndeterminate
      } = t2;
      return <><div className={styles.checkbox}><svg viewBox="0 0 18 18" aria-hidden="true">{isIndeterminate ? <rect x={1} y={7.5} width={15} height={3} /> : <polyline points="2 9 7 14 16 4" />}</svg></div>{children}</>;
    };
    $[3] = children;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <Checkbox className={styles.checkboxContainer} {...props}>{t1}</Checkbox>;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { AriaCheckbox };